module.exports = __webpack_public_path__ + "static/img/pedals-modulation.deaaaa3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/pedals-modulation.png
// module id = osgw
// module chunks = 12